import React from 'react';
import { EmbedPageQueryParamProviderContextType } from './types';

const EmbedPageQueryParamContext = React.createContext<
  EmbedPageQueryParamProviderContextType | undefined
>(undefined);

export default EmbedPageQueryParamContext;
